import latestStreamingReleasesQuery from 'src/components/lateststreamingreleases/latestStreamingReleasesQuery';
import LoadingIndicator from 'src/components/loadingindicator/LoadingIndicator';
import PosterRow from 'src/components/posterrow/PosterRow';
import { gql } from 'graphql-request';
import { useFilminfo } from 'src/lib/client/useFilminfo';
import { type StreamingContent } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';

/**
 * MERK: I det gamle malverket kunne man velge automatisert eller visning fra en publisert artikkel.
 * Publisert artikkel er ikke inkludert her fordi den ikke ble vedlikeholdt.
 */

//#region [Props]
type LatestStreamingReleasesProps = {
	className?: string;
	hideHeader?: boolean;
};
//#endregion

//#region [Component]
export default function LatestStreamingReleases({ className, hideHeader = false }: LatestStreamingReleasesProps) {
	const { fiLoading, fiData } = useFilminfo(latestStreamingReleasesQuery, { maxNumItems: 6 });

	return <aside className={className}>
		{!hideHeader && <SPopMoviesHeader>Siste på streaming</SPopMoviesHeader>}
		{fiLoading && <LoadingIndicator position='InlineCenter' />}
		{!fiLoading && <PosterRow posterList={fiData?.streamingQuery?.getNewStreamingContent as (undefined | null | StreamingContent[])} />}
	</aside>;
}
//#endregion

//#region [Styles]
const SPopMoviesHeader = styled.h2`
	color: var(--textcolor);
	margin: 10px 0;
`;
//#endregion
